import { isEmpty } from './index'

export const required = (value, minValue = 0) => {
  if (typeof value == 'string') {
    return value && value.length ? true : 'وارد کردن فیلد الزامی است.'
  }
  if (Array.isArray(value)) {
    return value !== [] && value.length > 0 ? true : 'انتخاب یک یا چند فیلد الزامی است.'
  }
  return value !== '' && value !== minValue && value !== null ? true : 'وارد کردن فیلد الزامی است.'
}
export const emailValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (Array.isArray(value)) {
    return value.every(val => re.test(String(val)))
  }

  return re.test(String(value)) || 'لطفا یک ایمیل معتبر وارد کنید.'
}

export const passwordValidator = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)

  return (
    // eslint-disable-next-line operator-linebreak
    validPassword || 'کلمه عبور باید شامل حروف کوچک و بزرگ، کاراکتر خاص و حداقل طول 8 کاراکتر باشد.'
  )
}

export const confirmedValidator = (value, target) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  value === target || 'The Confirm Password field confirmation does not match'

export const between = (value, min, max) => () => {
  const valueAsNumber = Number(value)

  return (Number(min) <= valueAsNumber && Number(max) >= valueAsNumber) || `لطفا عددی بین ${min} و ${max} وارد کنید`
}

export const integerValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  if (Array.isArray(value)) {
    return value.every(val => /^-?[0-9]+$/.test(String(val)))
  }

  return /^-?[0-9]+$/.test(String(value)) || 'فیلد باید عددی باشد.'
}

export const regexValidator = (value, regex) => {
  if (isEmpty(value)) {
    return true
  }

  let regeX = regex
  if (typeof regeX === 'string') {
    regeX = new RegExp(regeX)
  }

  if (Array.isArray(value)) {
    return value.every(val => regexValidator(val, { regeX }))
  }

  return regeX.test(String(value)) || 'The Regex field format is invalid'
}

export const alphaValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  // const valueAsString = String(value)

  return /^[A-Z]*$/i.test(String(value)) || 'The Alpha field may only contain alphabetic characters'
}

export const urlValidator = value => {
  if (value === undefined || value === null || value.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/

  return re.test(value) || 'URL is invalid'
}

export const lengthValidator = (value, length) => {
  if (isEmpty(value)) {
    return true
  }

  return value.length === length || `حداقل و حداکثر کاراکتر باید ${length} کارکتر باشد.`
}

export const validateMobileNumber = phone => {
  const re = /^09(1[0-9]|9[0-9]|0[0-9]|3[0-9]|2[0-9])-?[0-9]{3}-?[0-9]{4}$/
  return re.test(phone) || 'لطفا شماره موبایل معتبر وارد کنید.'
}

export const alphaDashValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  const valueAsString = String(value)

  return /^[0-9A-Z_-]*$/i.test(valueAsString) || 'All Character is not valid'
}

export const noPersianInput = value => {
  const regExp = /^[a-zA-Z0-9-#&^_.$\\/\\\\;.,@!?><:'"|+~`=%:*() \[\]{}]+$/
  const validData = regExp.test(value)

  return (
  // eslint-disable-next-line operator-linebreak
    validData || 'لطفا زبان کیبورد را انگلیسی کنید.'
  )
}

export const magicCodeValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  return value.length === 6 || 'رمز باید ۶ رقمی باشد'
}
